import pluginConfig from 'vue-gtm/src/config'

/**
 * Console log depending on config debug mode
 * @param {...*} message
 */
export const logDebug = function (message) {
  if (pluginConfig.debug) {
    console.log('VueGtm :', ...arguments)
  }
}

const SAFARI_ITP_MIN_VERSION = 16.4
const SAFARI_VERSION_PATTERN = /Version\/([0-9._]+)(.*Mobile)?.*Safari.*/
const COOKIE_KEEPER_LOADER_PREFIX = 'kp'
const STAPE_CONTAINER_ID_LENGTH = 8
const STAPE_LOADER_FILENAME_PATTERN = new RegExp(`([a-z]{${STAPE_CONTAINER_ID_LENGTH}})(\\.js)`)

/**
 * @return {boolean}
 */
const isSafariItp = function () {
  const match = SAFARI_VERSION_PATTERN.exec(navigator.userAgent)
  return !!match && parseFloat(match[1]) >= SAFARI_ITP_MIN_VERSION
}

/**
 * @param {String}  id
 * @param {String}  source
 * @return {String}
 */
const resolveScriptSrc = function (id, source) {
  if (!source.includes('?')) {
    return `${source}?id=${id}`
  }

  if (isSafariItp()) {
    return source.replace(STAPE_LOADER_FILENAME_PATTERN, `${COOKIE_KEEPER_LOADER_PREFIX}$1$2`)
  }

  return source
}

/**
 * Load GTM script tag
 * @param {String}  id      GTM ID
 * @param {String}  source  Script source URL (defaults to googletagmanager.com)
 */
export const loadScript = function (id, source = 'https://www.googletagmanager.com/gtm.js') {
  const win = window;
  const doc = document;
  const script = doc.createElement('script');
  const dl = 'dataLayer'

  win[dl] = win[dl] || []

  win[dl].push({
    event: 'gtm.js',
    'gtm.start': new Date().getTime()
  })

  if (!id) {
    return
  }

  script.async = true;
  script.src = resolveScriptSrc(id, source)

  doc.body.appendChild(script)
}

/**
 * Check if GTM script is in the document
 * @return {boolean}
 */
export const hasScript = function () {
  return Array
    .from(document.getElementsByTagName('script'))
    .some(script => script.src.includes('googletagmanager') || script.src.includes('/analytics/gtm.js'))
}
